import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ResetPasswordRoutingModule} from './reset-password-routing.module';
import {ResetPasswordComponent} from './reset-password.component';
import {TranslateModule} from "@ngx-translate/core";
import {MatInputModule} from "@angular/material/input";
import {ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import {FormFieldModule} from "@app/presentation/components/form-field/form-field.module";
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";
import {LoadingSpinnerModule} from "@app/presentation/components/loading-spinner/loading-spinner.module";
import {LocalizeRouterModule} from "@gilsdav/ngx-translate-router";


@NgModule({
  declarations: [
    ResetPasswordComponent
  ],
    imports: [
        CommonModule,
        ResetPasswordRoutingModule,
        ReactiveFormsModule,
        TranslateModule,
        MatInputModule,
        MatFormFieldModule,
        MatButtonModule,
        FormFieldModule,
        ButtonModule,
        AppBarModule,
        LoadingSpinnerModule,
        LocalizeRouterModule
    ]
})
export class ResetPasswordModule { }
